import React from 'react';
import {
  FileSyncAppLink,
  RolesAndAccessControlLink,
  StartFreeTrail,
} from 'constants/subscription';
import { Plan, PlanCost, PlanName } from './Plan';

type TeamPlanProps = {
  isActivePlan?: boolean;
  businessChooseText?: string;
  onSelect: () => void;
};

export const BusinessPlan = ({
  isActivePlan,
  businessChooseText,
  onSelect,
}: TeamPlanProps) => {
  return (
    <Plan
      name='Business'
      dataTestId='choosePlanPage-business-button'
      cost={<PlanCost size='small'>€45 per user/month</PlanCost>}
      details='Billed annually or €55 monthly'
      description={
        <span>
          Team workspace incl everything
          <p>
            in <span className='text-wfBlue font-bold'>Pro</span> plus:
          </p>
        </span>
      }
      planColor='black'
      features={[
        <div key='one-of-a-kind-1tbcs'>1TB of Private Cloud Storage</div>,
        <span key='Manufacturing'>Manufacturing Agent</span>,
        <span key='Unlimited Request for Quotes'>
          Unlimited Request for Quotes
        </span>,
        <div key='one-of-a-kind-1tbcs'>Unlimited AutoDFM (coming soon)</div>,
        'Priority customer support',
      ]}
      isActivePlan={isActivePlan}
      buttonText={businessChooseText || StartFreeTrail}
      onSelect={onSelect}
    />
  );
};
